export default __webpack_public_path__ + "img/instra4.44806088.jpg";